import { render } from "./TaxonomyEditor.vue?vue&type=template&id=4ad37196"
import script from "./TaxonomyEditor.vue?vue&type=script&lang=js"
export * from "./TaxonomyEditor.vue?vue&type=script&lang=js"

import "./TaxonomyEditor.vue?vue&type=style&index=0&id=4ad37196&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__